import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loadingMessage", "loader"]
  static values = { messages: Array, interval: Number }

  connect() {
    this.index = 0;
    this.messageIndex = 0;
    this.currentMessage = "";
    this.showNextMessage();
    
    // Set up a timeout to redirect after 1 minute (60,000 ms)
    this.redirectTimeout = setTimeout(() => this.checkAndRedirect(), 60000);
  }

  showNextMessage() {
    if (this.index < this.messagesValue.length) {
      this.currentMessage = this.messagesValue[this.index];
      this.messageIndex = 0;
      this.typeMessage();
    }
  }

  typeMessage() {
    if (this.messageIndex <= this.currentMessage.length) {
      this.loadingMessageTarget.innerHTML = `<span>${this.currentMessage.substring(0, this.messageIndex)}</span><span class="cursor">|</span>`;
      this.messageIndex++;

      setTimeout(() => this.typeMessage(), 75);
    } else {
      this.index++;
      if (this.index < this.messagesValue.length) {
        setTimeout(() => this.showNextMessage(), this.intervalValue || 2000);
      }
    }
  }

  checkAndRedirect() {
    if (!this.loaderTarget.classList.contains("hidden")) {
      window.location.href = "/strategic_plans";
    }
  }

  disconnect() {
    // Clear the redirect timeout when the controller is disconnected
    clearTimeout(this.redirectTimeout);
  }
}
